export const columns = [
  { displayText: 'Rule', propertyName: 'keywordRule' },
  { displayText: 'Created by', propertyName: 'addedBy' },
  { displayText: 'Creation Date', propertyName: 'formattedDateCreated' },
  { displayText: 'Value', propertyName: 'value' },
  { displayText: 'Priority', propertyName: 'priority' },
  { displayText: 'Apportionment', propertyName: 'apportionment' },
  { displayText: '', propertyName: null },
];
